<template>
    <div class="containter bg-white">
        <div class="productInfo">
            <div id="dashboardFunnelChart"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: () => 'countrySort'
        }
    },
    data() {
        return {
            titleObj: {
                countrySort: '按国家分类访客',
                source: '搜索来源访客'
            },
            renderData: {
                visitorQty: undefined,
                registerQty: undefined,
                registerQtyRate: undefined,
                createOrderQty: undefined,
                createOrderQtyRate: undefined,
                cartQty: undefined,
                cartQtyRate: undefined
            }
        }
    },
    computed: {
        topTitle() {
            return this.titleObj[this.type]
        },
        columns() {
            let arr = []
            if(this.type === 'countrySort') {
                arr = ['国家/地区', '访客', '占比']
            } else if(this.type === 'source') {
                arr = ['来源', '访客', '占比']
            }
            return arr
        }
    },
    mounted() {
        this.setOptions([])
    },
    methods: {
        setOptions(data) {
            this.saveRenderData(data)
            const that = this
            this.myChart = this.$echart.init(document.getElementById('dashboardFunnelChart'))
            let option;
            option = {
                title: {
                    text: '转化漏斗'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function(params) {
                        const { key, rateKey} = params.data;
                        const labelObj = {
                            visitorQty: '访客数',
                            registerQty: '注册数',
                            cartQty: '添加购物车数',
                            createOrderQty: '成功下单数'
                        }
                        let renderHtml = `<div style="padding: 4px 8px">${labelObj[key]} : ${that.renderData[key]}`
                        if(rateKey) {
                            renderHtml += '<br/>'
                            renderHtml += `转换率 : ${(that.renderData[rateKey] * 100).toFixed(2) || 0}%`
                        }
                        renderHtml += '</div>'
                        return renderHtml;
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                legend: {
                    data: ['Show', 'Click', 'Visit', 'Inquiry', 'Order']
                },
                series: [
                    {
                        name: 'Funnel',
                        type: 'funnel',
                        left: '10%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '0%',
                        maxSize: '100%',
                        sort: 'descending',
                        gap: 2,
                        label: {
                            show: true,
                            position: 'inside'
                        },
                        labelLine: {
                            length: 10,
                            lineStyle: {
                                width: 1,
                                type: 'solid'
                            }
                        },
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        emphasis: {
                            label: {
                                fontSize: 30
                            }
                        },
                        data: [
                            { value: 100, name: '访客', key: 'visitorQty', rateKey: null },
                            { value: 75, name: `注册 ${(that.renderData.registerQtyRate * 100).toFixed(2) || 0}%`, key: 'registerQty', rateKey: 'registerQtyRate' },
                            { value: 50, name: `添加购物车 ${(that.renderData.cartQtyRate * 100).toFixed(2) || 0}%`, key: 'cartQty', rateKey: 'cartQtyRate' },
                            { value: 25, name: `成功下单 ${(that.renderData.createOrderQtyRate *100).toFixed(2) || 0}%`, key: 'createOrderQty', rateKey: 'createOrderQtyRate' }
                        ]
                    }
                ],
                textStyle: {
                    fontSize: 20
                },
            };
            this.$nextTick(()=>{
                this.myChart.setOption(option)
            })
        },
        saveRenderData(data) {
            this.renderData = data
        }
    },
}
</script>

<style lang="scss" scoped>
.containter {
    width: 32%;
    min-width: 400px;
    padding: 20px;
    .top_title {
        >.font {
            font-weight: 600;
            height: 40px;
            line-height: 40px;
        }
    }
    .productInfo {
        #dashboardFunnelChart {
            width: 100%;
            height: 500px;
        }
    }
}
</style>